import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterService } from "angular2-toaster";
import { DomSanitizer } from '@angular/platform-browser';
import { of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoanService } from '../../shared-component/service/loan/loan.service';
import { ICustomWindow, WindowRefService } from './window.service';
import { environment } from '../../../environments/environment';
import { UtilService } from '../../util/util.service';

@Component({
  selector: 'app-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.scss']
})

export class TermsOfServiceComponent implements OnInit {

  public showeSignButton: boolean = false;
  public tokenId: string;
  private _window: ICustomWindow;
  public loanDetail: any = {};
  public tcTemplate: any;
  public companyName = environment.COMPANY_NAME;
  public digio: any;
  public link: any;
  public crd: any = {};
  public eMudraPopUpUrl: any;

  constructor(
    private router: Router,
    private loanService: LoanService,
    private winRef: WindowRefService,
    private activeRoute: ActivatedRoute,
    private toasterService: ToasterService,
    private utilService: UtilService,
    private sanitizer: DomSanitizer,
    private modalService: NgbModal,
  ) {
    this._window = winRef.nativeWindow;
  }

  ngOnInit() {
    this.utilService.getCurrentPosition(this);

    this.activeRoute.data.subscribe((res: any) => {
      this.loanDetail = res.loanDetail;
      this.tokenId = this.loanDetail.token;

      if (this.loanDetail.Loan &&
        this.loanDetail.Loan.DigioEsignRequest &&
        this.loanDetail.Loan.DigioEsignRequest.eSignRequestId) {
        if (this.loanDetail.Loan.DigioEsignRequest.eSignStatus == "Success" || this.loanDetail.Loan.DigioEsignRequest.eSignStatus == "Completed") {
          this.eSignResponseHandler({ message: "Process E-Sign Using Aadhar Completed." });
        }
      }
    });
  }

  public options: any = {
    environment: environment.DIGIO_ENVIRONMENT,
    logo: environment.COMPANY_LOGO,
    theme: {
      primaryColor: '#3D3BEE',
      secondaryColor: '#3D3BEE'
    },
    callback: ((response: any) => {
      if (!response.hasOwnProperty("error_code")) {
        this.eSignResponseHandler(response);
      }
      if (response.error_code == "CANCELLED") {
        this.showeSignButton = true;
      }
    }),
  };

  // Enables user/customer to continue with eMudra Keys.
  initiateeSignRequest() {
    this.showeSignButton = false;
    if (this.loanDetail.eSignPartner == "EMUDRA") {
      this.loanService.sendeSignRequest(this.tokenId).subscribe(
        (res: any) => {
          this.eMudraPopUpUrl = res.data.Loan.DigioEsignRequest.redirectionUrl ? res.data.Loan.DigioEsignRequest.redirectionUrl : res.data;

          // Set responsive popup dimensions based on the device's screen size
          const mediaQuery = window.matchMedia("(max-width: 600px)");
          const isMobile = mediaQuery.matches;
          const popupWidth = isMobile ? window.innerWidth * 0.9 : 500;
          const popupHeight = isMobile ? window.innerHeight * 0.8 : 600;

          // Calculate the position to center the popup on the screen
          const left = (window.innerWidth - popupWidth) / 2;
          const top = (window.innerHeight - popupHeight) / 2;

          // Prepare the popup options
          const popupOptions = `width=${popupWidth},height=${popupHeight},top=${top},left=${left},scrollbars=yes,resizable=yes`;

          // Store a reference to the popup window
          window.open(this.eMudraPopUpUrl, 'eMudraPopup', popupOptions);

          // Add a message event listener to catch messages from the popup
          window.addEventListener('message', (event) => {
            //console.log('Message from Popup:', event.data);
            const extractedStatusPart = event.data.status.substring(0, 7);
            if (extractedStatusPart == 'success') {
              this.eSignResponseHandler(extractedStatusPart);
            }});
            // if (this.loanDetail.applyInsurance && this.loanDetail.Loan.insuranceType == null) {
            //   this.initiateInsuranceAPI();
            // }
        })}
    else {
      this.loanService.sendeSignRequest(this.tokenId).subscribe((res: any) => {
        var digio = new this.winRef.nativeWindow['Digio'](this.options);
        digio.init();
        digio.submit(res.data.Loan.DigioEsignRequest.eSignRequestId, this.loanDetail.Customer.mobile);
        // if (this.loanDetail.applyInsurance && this.loanDetail.Loan.insuranceType == null) {
        //   this.initiateInsuranceAPI();
        // } 
      }, error => {
        this.showeSignButton = true;
        this.toasterService.pop('error', '', error.message);
      });
    }
  }
  
  async eSignResponseHandler(res: any) {
    const details = this.crd.data;
    this.loanService.updateeSignResponse(this.tokenId, details).subscribe((res: any) => {
      // window.location.reload();
      let LeadredirectionUrl = this.loanDetail.Lead ? this.loanDetail.Lead.redirectionUrl : "";
      if (LeadredirectionUrl) {
        if (!LeadredirectionUrl.startsWith('http://') && !LeadredirectionUrl.startsWith('https://')) {
          LeadredirectionUrl = 'https://' + LeadredirectionUrl;
        }
        this.toasterService.pop('success', '', 'Terms and conditions accepted successfully.');
        setTimeout(() => {
          window.location.href = LeadredirectionUrl;
        }, 2000)
      } else {
        window.location.reload();
      }
    })
   error => {
    this.showeSignButton = true;
    this.toasterService.pop('error', '', error.message);
  }
}

  async continue() {
    if (!this.crd.status) {
      return false;
    }
    const details = this.crd.data;
    this.loanService.loanAcceptingTermsConditions(this.tokenId, details).subscribe((res: any) => {
      // if (this.loanDetail.applyInsurance && this.loanDetail.Loan.insuranceType == null) {
      //   this.initiateInsuranceAPI();
      // } 
      let LeadredirectionUrl = this.loanDetail.Lead ? this.loanDetail.Lead.redirectionUrl : "";
      if (LeadredirectionUrl) {
        if (!LeadredirectionUrl.startsWith('http://') && !LeadredirectionUrl.startsWith('https://')) {
          LeadredirectionUrl = 'https://' + LeadredirectionUrl;
        }
        this.toasterService.pop('success', '', 'Terms and conditions accepted successfully.');
        setTimeout(() => {
          window.location.href = LeadredirectionUrl;
        }, 2000)
      } else {
        window.location.reload();
      }
    });
  }

  openNewWindowTermsAndConditions(content) {
    of(1).pipe(
      mergeMap(() => {
        return this.loanService.getTermsAndConditionsLetterPdf(this.tokenId);
      })
    ).subscribe((res: any) => {
      let url = res.data.signed;
      this.link = this.sanitizer.bypassSecurityTrustResourceUrl(`https://docs.google.com/viewer?url=${encodeURIComponent(url)}&embedded=true`);
      this.modalService.open(content, { backdrop: 'static', centered: true, size: 'lg' });
    });
  }

  changeEvent(event) {
    this.showeSignButton = !!event.target.checked;
  }
}
